<template>
  <section hidden="true">
    <h2>Testimonials</h2>
    <p>If possible, include quotes or feedback from colleagues or supervisors.</p>
    <p>Highlight any recognition or awards received at your company.</p>
  </section>
</template>

<script>
export default {
  name: 'TestimonialsSection'
}
</script>

<style scoped>
section {
  max-width: 950px;
  margin: 0 auto;
  padding: 20px;
  border-radius: 8px;
  color: var(--white-ish);
}

h2 {
  margin-top: 0;
  text-align: center;
}

p {
  margin: 10px 0;
  text-align: center;
}
</style>